import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * `/screener` — the section's front door. Advanced is the screener's one page with an API behind
 * it (the mock's Basic, Fundamental, Technical, Dividends and Custom have none), so the loader
 * always redirects there and `component` never renders on a real visit; a replace keeps the bare
 * URL out of the back stack.
 */
export const Route = createFileRoute('/_app/screener')({
  loader: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/screener/advanced', replace: true })
  },
  component: () => null,
})
